import React, { useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import Can from '../../../../features/components/Can'
import OutstandingActionsReminderModal from '../../../../features/components/Modals/OutstandingActionsReminderModal'
import Button from '../../../../components/Button'

import { openForm } from '../../../../modules/actions/forms'

import { RIGHT_CREATE } from '../../../../constants/forms'
import { OUTSTANDING_ACTIONS_NOTIFICATION, RIGHT } from '../../../../constants/permissions'

const RightsListActions = ({ rightsList, isAdvancedPartnership }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const showOutstandingActionsReminder = useMemo(() => {
    return rightsList.find(item => item.action || item.creative_assets_required || item.logo_required)
  }, [rightsList])

  const openRightCreateForm = useCallback(() => {
    dispatch(openForm({ formName: RIGHT_CREATE }))
  }, [dispatch])

  return (
    <>
      {showOutstandingActionsReminder && (
        <Can I={'manage'} a={OUTSTANDING_ACTIONS_NOTIFICATION}>
          <OutstandingActionsReminderModal />
        </Can>
      )}
      {!isAdvancedPartnership && (
        <Can I={'create'} a={RIGHT}>
          <Button onClick={openRightCreateForm}>{t('Create a new right')}</Button>
        </Can>
      )}
    </>
  )
}

RightsListActions.propTypes = {
  rightsList: PropTypes.array.isRequired,
  isAdvancedPartnership: PropTypes.bool.isRequired
}

export default RightsListActions
